import { LocalizedValue } from '@osos/shared/api';
import { FileModel } from '../file.model';
import { RefProperty } from '../ref-property.model';

export type CommentAudiencePresenterModel = {
  users?: Array<RefProperty>;
  groups?: Array<RefProperty>;
};
export class CommentPresenterModel {
  id: string;
  specificationVersion: number;
  commentText?: string | null;
  attachments?: FileModel[];
  commenter: RefProperty;
  delegetee?: RefProperty;
  doneAt: string;
  relatedTo: RefProperty;
  mentions?: Array<RefProperty>;
  entityId?: string;
  entryId?: string;
  workflowStepId?: string;
  workflowStepName?: LocalizedValue;
  audience?: CommentAudiencePresenterModel;
}
